<template>
    <v-app-bar
        app
        color="transparent"
        class="app-bar"
        elevation="0"
        dark>
        <div class="d-flex align-center">
            <v-btn
                href="/#home"
                icon
                class="mr-2"
                color="secondary"
                width="64"
                height="64"
                aria-label="Back to top">
                <v-icon size="64">mdi-account-circle</v-icon>
            </v-btn>

            <div class="hidden-sm-and-down secondary--text font-weight-light text-h6">Portfolio</div>
        </div>

        <v-spacer />

        <v-btn
            icon
            color="secondary"
            :title="`${themes[next].label} theme`"
            :aria-label="`Switch to the ${themes[next].label} theme`"
            @click="select(next)">
            <v-icon>{{ themes[next].icon }}</v-icon>
        </v-btn>
        <v-btn
            :href="profile.cvUrl"
            target="_blank"
            color="secondary"
            text>
            <span class="mr-2">CV</span>
            <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn
            href="/#contact"
            color="secondary"
            text>
            <span class="mr-2">Contact</span>
            <v-icon>mdi-phone</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
import { profile } from '@/data/profile';
import { themes } from '@/styles/themes';
import { useThemeVariant } from '@/composables/useThemeVariant';

export default {
    name: 'AppBar',
    setup() {
        const { next, select } = useThemeVariant();

        return { profile, themes, next, select };
    },
};
</script>

<style scoped>
.app-bar {
    background: linear-gradient(to right, var(--v-backdrop-start-base), var(--v-backdrop-end-base));
}
</style>
